<div class="not-connected-section">
  <div class="not-connected-content">
    <h2 class="section-title">🔗 Connect Your Wallet</h2>
    <p class="not-connected-description">
      {{ description }}
    </p>
    <button (click)="connect()" class="retro connect">
      Connect Wallet
    </button>
  </div>
</div>

